import API_BASE_URL from "../../../../../Constants";

export const fetchAllDevices = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch devices:", error);
    throw error;
  }
};

export const fetchAssignedDevices = async (buildingId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/${buildingId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch assigned devices:", error);
    throw error;
  }
};

export const getDeviceById = async (deviceId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/${deviceId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch device:", error);
    throw error;
  }
};

export const addDevice = async (buildingID, deviceID) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/${deviceID}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          buildingId: buildingID,
        }),
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to add device:", error);
    throw error;
  }
};

export const removeDevice = async (deviceID) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/${deviceID}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          buildingId: null,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to remove device:", error);
    throw error;
  }
};

export const updateDevice = async (deviceID, deviceData) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices/${deviceID}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(deviceData),
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to update device:", error);
    throw error;
  }
};

export const createNewDevice = async (deviceData) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/devices`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(deviceData),
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to create device:", error);
    throw error;
  }
};
